import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { InternalDragHandle, } from "@amzn/awsui-components-react/polaris/internal/do-not-use/drag-handle";
import { CLICK_DRAG_THRESHOLD } from "../item-container";
import styles from "./styles.css.js";
import testUtilsStyles from "./test-classes/styles.css.js";
export default function ResizeHandle({ ariaLabelledBy, ariaDescribedBy, onPointerDown, onKeyDown, activeState, onDirectionClick, resizeHandleTooltipText, }) {
    return (_jsx(InternalDragHandle, { className: clsx(styles.handle, activeState === "pointer" && styles.active, activeState === "uap" && testUtilsStyles["active-uap"]), ariaLabelledBy: ariaLabelledBy, ariaDescribedby: ariaDescribedBy, variant: "resize-area", tooltipText: resizeHandleTooltipText, onKeyDown: onKeyDown, onPointerDown: onPointerDown, directions: {
            "block-start": "active",
            "block-end": "active",
            "inline-start": "active",
            "inline-end": "active",
        }, triggerMode: "keyboard-activate", onDirectionClick: onDirectionClick, hideButtonsOnDrag: true, clickDragThreshold: CLICK_DRAG_THRESHOLD }));
}
//# sourceMappingURL=index.js.map